import { joinParts } from './utils'

export const support = {
  conversation: (code?: string) => joinParts('support', 'conversation', code),
  form: () => joinParts('support', 'form'),
}
